import { TTicketData } from 'views/types/tickets';
import { create, useStore } from 'zustand';

interface ITicketsStore {
  tickets: TTicketData[];
  loading: boolean;
  getBy: 'all' | 'byTicketId' | 'byUserId' | 'byAdminId';
  setTickets: (tickets: TTicketData[]) => void;
  setLoading: (loading: boolean) => void;
  setGetBy: (type: 'all' | 'byTicketId' | 'byUserId' | 'byAdminId') => void;
}

export const ticketsStore = create<ITicketsStore>(set => ({
  tickets: [],
  loading: false,
  getBy: 'all',
  setLoading: loading => set({ loading }),
  setTickets: tickets => set({ tickets }),
  setGetBy: getBy => set({ getBy, tickets: [] }),
}));

export const useTicketsStore = () => useStore(ticketsStore);
